import { getValidAccessToken } from '../../api/auth/token'
const signalR = require('@microsoft/signalr')

// Exponential backoff capped at 60s. Returning a positive number indefinitely
// keeps the client retrying — the default withAutomaticReconnect() gives up
// after 4 attempts, which is what made dropped connections "stay down".
const reconnectPolicy = {
    nextRetryDelayInMilliseconds: retryContext => {
        const elapsed = retryContext.elapsedMilliseconds
        if (elapsed < 60_000) return 2_000
        if (elapsed < 5 * 60_000) return 10_000
        return 30_000
    }
}

export const createConnection = (url, callbacks) => {

    const connection = new signalR.HubConnectionBuilder()
        .withServerTimeout(60*1000)
        .withKeepAliveInterval(15*1000)
        .withAutomaticReconnect(reconnectPolicy)
        .withUrl(url, {
            // Async + refresh-aware: SignalR awaits this on every negotiate and
            // reconnect, so a connection re-established after the tab was idle
            // always presents a valid token instead of a stale one.
            accessTokenFactory: () => getValidAccessToken()
        })
        .build()

    for (let prop in callbacks) {
        if (callbacks.hasOwnProperty(prop)) {
            connection.on(prop, callbacks[prop])
        }
    }
    return connection
}
